import React from 'react';
import {Form, Row, Col, Input, DatePicker, Radio, Upload, Button, Select} from 'antd';
import {UploadOutlined} from '@ant-design/icons';
import './timesheet.css';
import {ACCESS_OPTIONS, USER_ROLE_OPTIONS} from "./constants";

const {RangePicker} = DatePicker;

const UserForm = ({
                      form,
                      onSubmit,
                      loading,
                      managerList,
                      externalManagerList,
                      isUpdate = false,
                      normFile,
                      beforeUploadPdfExcel,
                      onPreview,
                      userRole
                  }) => {
    const selectedRole = Form.useWatch('role', form);
    const isManagerSelected = ['manager', 'external manager'].includes(selectedRole);

    return (
        <Form form={form} layout="vertical" className="bold-labels">

            {userRole === 'admin' && (
                <Form.Item name="role" label="Role" rules={[{required: true, message: "Role is required"}]}>
                    <Select placeholder="Select a role">
                        {USER_ROLE_OPTIONS.map((role) => (
                            <Select.Option key={role.value} value={role.value}>
                                {role.label}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            )}

            <Row gutter={16}>
                {!isManagerSelected && (
                    <Col span={12}>
                        <Form.Item
                            label="Full Name"
                            name="full_name"
                            rules={[{required: true, message: "Full name is required"}]}
                        >
                            <Input placeholder="Enter full name"/>
                        </Form.Item>
                    </Col>)}
                <Col span={12}>
                    <Form.Item
                        label="Email ID"
                        name="email"
                        rules={[{required: true, message: "Email is required"}, {type: "email"}]}
                    >
                        <Input disabled={isUpdate} placeholder="Enter email ID"/>
                    </Form.Item>
                </Col>
            </Row>

            {!isManagerSelected && (
                <>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Mobile Number"
                                name="mobile_number"
                                rules={[{required: true, message: "Mobile number is required"}]}
                            >
                                <Input placeholder="Enter mobile number"/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Company Name"
                                name="company_name"
                                rules={[{required: true, message: "Company name is required"}]}
                            >
                                <Input placeholder="Enter company name"/>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Project (Can add multiple projects)"
                                name="project"
                                rules={[{required: true, message: "At least one project is required"}]}
                            >
                                <Select
                                    mode="tags"
                                    style={{width: '100%'}}
                                    placeholder="Enter project name and press enter to add other projects"
                                    // disabled={isUpdate}
                                    open={false}
                                    suffixIcon={null}
                                    tokenSeparators={[',']}
                                >
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                className="red-picker-scope"
                                label="Work Duration"
                                name="date_range"
                                rules={[{required: true, message: "Work start and end date is required"}]}
                            >
                                <RangePicker className="w-full red-picker"/>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16} align="top" wrap={false}>
                        <Col xs={24} md={12}>
                            <Form.Item label="VPN Access" name="vpn_access" initialValue="Not Required">
                                <Radio.Group>
                                    {ACCESS_OPTIONS.map((access) => (
                                        <Radio key={access.value} value={access.value}>
                                            {access.label}
                                        </Radio>
                                    ))}
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item noStyle dependencies={['vpn_access']}>
                                {({getFieldValue}) => getFieldValue('vpn_access') === 'Required' && (
                                    <Form.Item label="VPN Profile" name="vpn_profile"
                                               rules={[{required: true, message: 'VPN profile is required'}]}>
                                        <Input placeholder="Enter VPN Profile"/>
                                    </Form.Item>
                                )}
                            </Form.Item>

                            <Form.Item label="Domain Access" name="domain_access" initialValue="Not Required">
                                <Radio.Group>
                                    {ACCESS_OPTIONS.map((access) => (
                                        <Radio key={access.value} value={access.value}>
                                            {access.label}
                                        </Radio>
                                    ))}
                                </Radio.Group>
                            </Form.Item>
                            {isUpdate &&
                                <Form.Item noStyle dependencies={['domain_access']}>
                                    {({getFieldValue}) => getFieldValue('domain_access') === 'Required' && (
                                        <Form.Item label="Domain Profile" name="domain_profile"
                                                   rules={[{required: true, message: 'Domain profile is required'}]}>
                                            <Input placeholder="Enter Domain Profile"/>
                                        </Form.Item>
                                    )}
                                </Form.Item>
                            }

                            <Form.Item label="Company Email" name="company_email" initialValue="Not Required">
                                <Radio.Group>
                                    {ACCESS_OPTIONS.map((access) => (
                                        <Radio key={access.value} value={access.value}>
                                            {access.label}
                                        </Radio>
                                    ))}
                                </Radio.Group>
                            </Form.Item>
                            {isUpdate && (
                                <Form.Item noStyle dependencies={['company_email']}>
                                    {({getFieldValue}) =>
                                        getFieldValue('company_email') === 'Required' ? (
                                            <Form.Item
                                                label="Assigned Company Email"
                                                name="assigned_company_email"
                                                rules={[{
                                                    required: true,
                                                    message: 'Assigned company email is required'
                                                }]}
                                            >
                                                <Input placeholder="Enter Assigned Email"/>
                                            </Form.Item>
                                        ) : null
                                    }
                                </Form.Item>
                            )}
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item label="NDA/MSA Document" name="NDA_doc" valuePropName="fileList"
                                       getValueFromEvent={normFile}>
                                <Upload name="nda" accept=".pdf,.xls,.xlsx" beforeUpload={beforeUploadPdfExcel}
                                        maxCount={1}
                                        onPreview={onPreview}>
                                    <Button icon={<UploadOutlined/>}>Upload NDA/MSA</Button>
                                </Upload>
                            </Form.Item>

                            <Form.Item label="Other Attachments" name="other_doc" valuePropName="fileList"
                                       getValueFromEvent={normFile}>
                                <Upload name="others" accept=".pdf,.xls,.xlsx" multiple
                                        beforeUpload={beforeUploadPdfExcel}
                                        onPreview={onPreview}>
                                    <Button icon={<UploadOutlined/>}>Upload Others</Button>
                                </Upload>
                            </Form.Item>

                            {(isUpdate && userRole === "admin") && (
                                <Form.Item
                                    label="Backfill Permission"
                                    name="can_backfill"
                                    initialValue={false}
                                >
                                    <Radio.Group
                                        buttonStyle="solid"
                                        className="custom-radio-group"
                                    >
                                        <Radio.Button value={true}>
                                            Allow Backfill
                                        </Radio.Button>
                                        <Radio.Button value={false}>
                                            Deny Backfill
                                        </Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            )}

                        </Col>
                    </Row>

                    <Row gutter={16} className="mt-3">
                        <Col span={24}>
                            <Form.Item label="Assign Additional Managers (Max 2)" name="selected_managers">
                                <Select mode="multiple" placeholder="Select managers"
                                        maxCount={userRole === "admin" ? 3 : 2}
                                        style={{width: '100%'}}>
                                    {managerList?.map((manager) => (
                                        <Select.Option key={manager.email} value={manager.email}>
                                            {manager.email}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="Assign Additional External Managers (Max 2)"
                                       name="selected_external_managers">
                                <Select mode="multiple" placeholder="Select external managers" maxCount={2}
                                        style={{width: '100%'}}>
                                    {externalManagerList?.map((manager) => (
                                        <Select.Option key={manager.email} value={manager.email}>
                                            {manager.email}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </>
            )}

            <Row justify="end" gutter={16} className="mt-2">
                <Col>
                    <Button onClick={() => form.resetFields()}>Reset</Button>
                </Col>
                <Col>
                    <Button
                        type="primary"
                        onClick={onSubmit}
                        danger
                        loading={loading}
                    >
                        {isUpdate ? "Update" : "Submit"}
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export default UserForm;